import { t } from 'i18next'
import React, { useCallback, useMemo, useState, useEffect } from 'react'
import { Alert, Modal, Button } from 'react-bootstrap'
import { ButtonWithLoadingState } from '../Buttons'
import UniversalTableWrapperTest from '../Table/UniversalTableWrapperTest'
import BootstrapTable from 'react-bootstrap-table-next'
import { useTableState } from '../Table/TableProvider'
import { getErrorMessageFromApiResponse } from '../../utils/api/apiUtils'
import { APIEndpoints } from '../../utils/api/apiConfig'
import apiClient from '../../utils/api/apiClient'
import { DeleteIcon } from '../Icons/DeleteIcon'
import { emptyGuid, isEmptyGuid } from '../../utils/emptyGuid'
import { isEmptyStr, newGuid } from '../../utils/objectutils'
import cellEditFactory from 'react-bootstrap-table2-editor'
import styled from 'styled-components'
import useStores from '../../stores/useStore'
import { PrinterIcon } from '../Icons/PrinterIcon'

export const ResponsiveButton = styled.div`
  width: 100%;
  @media (max-width: 768px) {
    width: 100%;
  }
  button {
    width: auto;
    @media (max-width: 768px) {
      width: 100% !important;
    }
  }
`

const StyledHeaderCell = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`
const CreateRFIDInstance = ({
  handleClose,
  article,
  articleVariant,
  handleUpdateInstances,
  disabledAutoGenerator,
}) => {
  const [success, setSuccess] = useState('')
  const [error, setError] = useState('')
  const [isSaving, setIsSaving] = useState(false)
  const { tableRef } = useTableState()

  const [loading, setLoading] = useState(false)
  const { inventoryStore, uiStore } = useStores()

  const [allSelected, setAllSelected] = useState(false)
  const [selectedCheckBoxes, setSelectedCheckBoxes] = useState([])
  const [articleInstances, setArticleInstances] = useState([])

  useEffect(() => {
    const init = async () => {
      setLoading(true)
      let variantId = articleVariant?.id ?? emptyGuid
      let positions = isEmptyGuid(variantId)
        ? article.positions
        : article.positions.filter(
            (x) => (x.articleVariant?.id ?? emptyGuid) === variantId
          )
      let rowInstances = []
      positions.forEach((position) => {
        position.rows.forEach((row) => {
          let rowInst = {
            article: article.article,
            variant: position.articleVariant,
            batchKey: row.instance?.batchKey ?? '',
            serialKey: row.instance?.serialKey ?? '',
            rfid: row.instance?.rfid ?? '',
            rfidIsEditable: isEmptyStr(row.instance?.rfid ?? ''),
            rfidIsDeletable: false, //!isEmptyStr(row.instance?.rfid ?? ''),
            instanceId: row.instance?.instanceId ?? emptyGuid,
            trackingId: row.instance?.trackingId ?? emptyGuid,
            id: newGuid(),
          }
          rowInstances.push(rowInst)
        })
      })
      rowInstances = rowInstances.map((item) => ({
        ...item,
        checkBox: (
          <span>
            <input
              type='checkbox'
              id={item.id}
              name='scales'
              checked={false}
              onChange={() => {}}
            ></input>
          </span>
        ),
      }))
      setArticleInstances(rowInstances)
      setAllSelected(false)
      setSelectedCheckBoxes([])
      setLoading(false)
    }
    init()
  }, [article, articleVariant, inventoryStore.instances])

  useEffect(() => {
    setArticleInstances((prev) =>
      prev.map((item) => ({
        ...item,
        checkBox: (
          <span>
            <input
              type='checkbox'
              id={item.id}
              name='scales'
              checked={selectedCheckBoxes.includes(item.id)}
              onChange={() => {}}
            ></input>
          </span>
        ),
      }))
    )
  }, [selectedCheckBoxes])
  const columns = useMemo(
    () => [
      {
        dataField: 'checkBox',
        text: '',
        headerClasses: 'checkBox-header-cell',
        classes: 'checkBox-cell',
        editable: false,
      },
      {
        dataField: 'article.articleNumber',
        text: 'localInventoriesTable:articleNumber',
        sort: true,
        editable: false,
      },
      {
        dataField: 'article.displayName',
        text: 'localInventoriesTable:articleName',
        sort: true,
        editable: false,
      },
      {
        dataField: 'variant.displayName',
        text: 'localInventoriesTable:sizeName',
        sort: true,
        editable: false,
      },
      {
        dataField: 'serialKey',
        text: 'localInventoriesTable:serialkey',
        sort: true,
        editable: false,
      },
      {
        dataField: 'batchKey',
        text: 'localInventoriesTable:batchKey',
        sort: true,
        editable: false,
      },
      {
        dataField: 'rfid',
        text: 'inventory:scanCode',
        sort: true,
        classes: 'cursor-pointer',
        editable: (cell, row, rowIndex, colIndex) => {
          return row.rfidIsEditable
        },
      },
      {
        isDummyField: true,
        dataField: 'isDummyField',
        text: '',
        sort: false,
        headerClasses: 'checkBox-header-cell',
        classes: 'checkBox-cell',
        editable: (cell, row, rowIndex, colIndex) => {
          return false
        },
        formatter: (cell, row, rowIndex, extraProps) =>
          row.rfidIsDeletable ? (
            <span
              role='button'
              onClick={(e) => {
                extraProps.handleRemoveRow(e)(row, cell)
              }}
            >
              <DeleteIcon title={t('delete')} />
            </span>
          ) : null,
      },
    ],
    []
  )
  const onRowClick = (cell, row) => {
    const { cursor } = getComputedStyle(cell.target)
    if (cursor === 'pointer') {
      return false
    }
    if (allSelected) {
      setAllSelected(false)
    }
    if (selectedCheckBoxes.includes(row.id)) {
      var index = selectedCheckBoxes.indexOf(row.id)
      var newValues = [...selectedCheckBoxes]
      newValues.splice(index, 1)
      setSelectedCheckBoxes(newValues)
    } else {
      setSelectedCheckBoxes((prev) => [...prev, row.id])
    }
  }
  const handlePrint = () => {
    let printBarcodeNumbers = articleInstances
      .filter((x) => selectedCheckBoxes.includes(x.id))
      .map((e) => {
        return e.rfid
      })
    if (!printBarcodeNumbers?.length) {
      return false
    }
    sessionStorage.setItem(
      'printBarcodeNumbers',
      JSON.stringify(printBarcodeNumbers)
    )
    const urlPrefix = `${'/' + uiStore.theme + '/' + uiStore.language}`
    const basename = process.env.PUBLIC_URL + urlPrefix
    window.open(
      `${basename}/inventoryAction/assets/${inventoryStore.employeeId}/print`,
      '_blank',
      ' top=400,left=400,width = 1000, height = 600'
    )
  }
  const selectAll = useCallback(() => {
    if (allSelected || articleInstances.length < 1) {
      setAllSelected(false)
      setSelectedCheckBoxes([])
    } else {
      const arrayOfAllIds = articleInstances.map((obj) => obj.id)
      setSelectedCheckBoxes(arrayOfAllIds)
      setAllSelected(true)
    }
  }, [articleInstances, allSelected])
  const handleRemoveRow = useCallback((e) => (row, cell) => {}, [])
  const handleAfterSaveCell = (oldValue, newValue, row, column) => {
    var inventories = [...articleInstances]
    let foundIndex = inventories.findIndex((item) => item.id === row.id)
    if (foundIndex >= 0) {
      inventories[foundIndex].rfid = newValue
      setArticleInstances(inventories)
    }
  }

  const preparedColumns = useMemo(() => {
    const tmpColumns = [...columns]
    tmpColumns.forEach((tmpColumn) => {
      tmpColumn.headerFormatter = (column, colIndex, components) => {
        switch (tmpColumn.dataField) {
          case 'checkBox':
            return (
              <span>
                <input
                  type='checkbox'
                  id='checkbox_header'
                  name='scales'
                  checked={allSelected}
                  onChange={selectAll}
                ></input>
              </span>
            )
          default:
            return (
              <>
                <StyledHeaderCell>
                  {column.text}
                  {components.sortElement}
                </StyledHeaderCell>
              </>
            )
        }
      }
    })
    tmpColumns.forEach((tmpColumn) => {
      tmpColumn.text = t(tmpColumn.text)
    })
    tmpColumns.find((col) => col.dataField === 'isDummyField').formatExtraData =
      {
        handleRemoveRow,
      }
    const ignoreColumns = () => {
      var result = []
      if (!articleInstances.find((x) => !isEmptyGuid(x.variant?.id))) {
        result.push('variant.displayName')
      }
      if (!articleInstances.find((x) => x.serialKey)) {
        result.push('serialKey')
      }
      if (!articleInstances.find((x) => x.batchKey)) {
        result.push('batchKey')
      }
      if (!articleInstances.find((x) => x.rfidIsDeletable)) {
        result.push('isDummyField')
      }
      return result
    }

    return tmpColumns.filter(
      (item) => !ignoreColumns().includes(item.dataField)
    )
  }, [handleRemoveRow, columns, allSelected, articleInstances, selectAll])
  const saveData = async (generateRFID = false) => {
    let instancesData = articleInstances
      .filter(
        (x) =>
          x.rfidIsEditable &&
          ((!generateRFID && !isEmptyStr(x.rfid ?? '')) ||
            (generateRFID && selectedCheckBoxes.includes(x.id)))
      )
      .map((e) => {
        return {
          trackingId: e.trackingId,
          instanceId: e.instanceId,
          articleId: e.article.id,
          variantId: e.variant?.id ?? emptyGuid,
          serialKey: e.serialKey,
          batchKey: e.batchKey,
          rfid: e.rfid,
          id: e.id,
        }
      })
    let params = {
      instances: instancesData,
      generateKeyNumber: generateRFID,
    }
    let resp = await apiClient.postJson(
      APIEndpoints.businessPartner(inventoryStore.employeeId).instances,
      params
    )
    if (handleUpdateInstances) {
      handleUpdateInstances(resp)
      return
    }
    instancesData.forEach((arr, index) => {
      let savedItem = resp[index]
      var inventories = [...articleInstances]
      let foundIndex = inventories.findIndex((item) => item.id === arr.id)
      if (foundIndex >= 0) {
        inventoryStore.updateInstances(
          article,
          articleVariant,
          savedItem,
          foundIndex
        )
      }
    })
    return resp
  }

  const handleSave = async (generateRFID = false) => {
    setIsSaving(true)
    setError('')
    try {
      await saveData(generateRFID)
      await inventoryStore.loadAllInstances(true)
      setSuccess(t('EmployeeFormSidebar:dataSaved'))
    } catch (e) {
      setError(getErrorMessageFromApiResponse(e))
    }
    setIsSaving(false)
  }
  return (
    <Modal size='xl' centered show={true} onHide={handleClose} scrollable>
      <Modal.Header closeButton className='pb-0'>
        <Modal.Title>
          <div>
            <p className='m-0 pt-2'>{t('inventory:scanCodeAdmin')}</p>
          </div>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <UniversalTableWrapperTest>
          <BootstrapTable
            ref={tableRef}
            loading={loading}
            noDataIndication={() => (
              <div className='no-data-placeholder'>{t('inventory:noData')}</div>
            )}
            bootstrap4
            keyField='id'
            hover
            data={articleInstances}
            columns={preparedColumns}
            bordered={false}
            rowEvents={{ onClick: onRowClick }}
            cellEdit={cellEditFactory({
              mode: 'click',
              blurToSave: true,
              afterSaveCell: handleAfterSaveCell,
              autoSelectText: true,
            })}
          />
        </UniversalTableWrapperTest>
        {error ? <Alert variant='danger'>{error}</Alert> : null}
        {success ? <Alert variant='success'>{success}</Alert> : null}
      </Modal.Body>
      <Modal.Footer>
        <Button variant='secondary' onClick={handleClose}>
          {t('cancelButton')}
        </Button>
        <Button
          variant='secondary'
          onClick={handlePrint}
          disabled={!selectedCheckBoxes?.length}
        >
          <PrinterIcon className='me-2' />
          {t('inventory:drucken')}
        </Button>
        {!disabledAutoGenerator && (
          <ButtonWithLoadingState
            variant='primary'
            buttonText={t('inventory:generateScanCode1')}
            isLoading={isSaving}
            disabled={
              !articleInstances.some(
                (x) =>
                  x.rfidIsEditable &&
                  isEmptyStr(x.rfid ?? '') &&
                  selectedCheckBoxes.includes(x.id)
              )
            }
            onClick={(e) => handleSave(true)}
          />
        )}
        <ButtonWithLoadingState
          variant='primary'
          buttonText={t('inventory:generateScanCode2')}
          isLoading={isSaving}
          disabled={
            !articleInstances.some(
              (x) => x.rfidIsEditable && !isEmptyStr(x.rfid ?? '')
            )
          }
          onClick={(e) => handleSave(false)}
        />
      </Modal.Footer>
    </Modal>
  )
}

export default CreateRFIDInstance
